import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { RenderField, RenderTextareaField, RenderSubmitButton } from '../../../common/form';
import * as Validations from '../../../common/form/commonValidations';
import { addRegistry, updateRegistry } from '../../../../actions/website/entities/RegistryActions';
import { hideModal } from '../../../../actions/ModalActions';

const RegistryForm = ({ handleSubmit, submitting, valid, isUpdate }) => (
  <div className="entity-form">
    <div className="modal-header add-existing-registry-header">
      <h3 className="modal-title">We&apos;re the Registry Experts</h3>
      <div className="row margin-top">
        <p className="col-sm-6">Enjoy everything you and your family love about your favorite department store and so much more at Zola.</p>
      </div>
      <div className="row">
        <div className="col-sm-6">
          <a href="/wedding/manage/registry-onboard">Take a Tour of Zola Registry &rsaquo;</a>
        </div>
      </div>
    </div>
    <div className="modal-body">
      <h3 className="modal-title with-bottom-spacing">{isUpdate ? 'Edit' : 'Add'} Existing Registry</h3>
      <form onSubmit={handleSubmit} noValidate>
        <Field
          name="name"
          id="registry-name"
          label="Registry Store Name"
          type="text"
          component={RenderField}
          validate={[Validations.REQUIRED, Validations.MAX_LENGTH_40]}
          maxChars={40}
          required
        />
        <Field
          name="url"
          id="registry-url"
          label="Registry Website Address"
          type="url"
          component={RenderField}
          validate={[Validations.REQUIRED, Validations.NOT_ZOLA]}
          required
        />
        <Field
          name="description"
          id="registry-note"
          label="Note For Guests"
          placeholder="A few of our favorite things from this store."
          registryUrl
          component={RenderTextareaField}
          maxChars={1000}
          validate={Validations.MAX_LENGTH_1000}
        />
        <RenderSubmitButton pristine={false} submitting={submitting} valid={valid} />
      </form>
    </div>
  </div>
);

RegistryForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  isUpdate: PropTypes.bool
};

export const asyncValidate = (value) => {
  const urlValue = value.url;
  return new Promise((resolve) => {
    if (Validations.VALIDATE_URL(urlValue)) {
      resolve();
    } else {
      throw Object.assign({}, { url: 'Please enter a valid URL' });
    }
  });
};

const RegistryFormInstance = reduxForm({
  form: 'registryForm',
  asyncValidate,
  asyncBlurFields: ['url'],
})(RegistryForm);

const mapStateToProps = state => (
  {
    initialValues: state.website.entities.byId[state.website.entities.selectedEntityId],
  }
);

const mapDispatchToProps = dispatch => (
  {
    onSubmit: (registryFormRequest) => {
      if (registryFormRequest.id) {
        dispatch(updateRegistry(registryFormRequest));
      } else {
        dispatch(addRegistry(registryFormRequest));
      }
      dispatch(hideModal());
    },
  }
);

const RegistryFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistryFormInstance);

export default RegistryFormContainer;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/RegistryFormv2.jsx